import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ADMIN_ANEEL_TARIFFS_ENDPOINTS, AdminAneelTariffs } from "@/service/api/admin-aneel-tariffs";

const useImportAneelTariffs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AdminAneelTariffs.importTariffs,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_TARIFFS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_LAST_UPDATE] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_IMPORT_HISTORY] });
    },
  });
};

export default useImportAneelTariffs;
